export default __webpack_public_path__ + "static/basta-casinon-med-swish-hos-casinolabbet-ce5031ddaf6d56eb913f1dfb57fb6e03.jpg";